import { Ellipsis } from 'lucide-react';

import IconButton from '@/components/Button/IconButton';
import Menu from '@/components/Menu/Menu';
import Modal from '@/components/Modal/Modal';
import useModalState from '@/hooks/pure/useModalState';

import type { ProductHierarchy } from '../../types';
import { DeleteModal } from './DeleteModal';

type Props = {
  target: ProductHierarchy;
  targetId: string;
};

export const ProductManagerEllipsisMenu = (props: Props) => {
  const modalState = useModalState();

  return (
    <>
      <Menu
        triggerNode={
          <IconButton
            icon={<Ellipsis className="size-4" />}
            sizeType="s"
            outlined={false}
          />
        }
        options={[
          {
            label: 'Delete',
            className: 'text-destructive font-medium',
            onClick: async () => {
              modalState.open();
            },
          },
        ]}
      />
      <Modal status={modalState.status} closeModal={modalState.close}>
        <DeleteModal target={props.target} targetId={props.targetId} />
      </Modal>
    </>
  );
};
